<template>
  <w-setting-sliding-popup v-loading="isLoading" ref="slidingPopup" title="네트워크 수동 등록" width="500px" @close="close" @open="open">
    <div slot="content">
      <el-form :model="networkFormData" label-position="top" ref="networkForm" :rules="rules">
        <div class="mr-b25">
          <el-row class="title-bar">
            <h4>기본정보</h4>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="장비명" prop="objName">
                <el-input v-model="networkFormData.objName" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="장비 종류" prop="objtypeId">
                <el-select v-model="networkFormData.objtypeId" style="width:100%">
                  <el-option v-for="item in objtypeList" :key="item.objtypeId" :label="item.objtypeName" :value="item.objtypeId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="IP 타입" prop="ipaddressApplytype">
                <el-select v-model="networkFormData.ipaddressApplytype" style="width:100%">
                  <el-option v-for="item in iptypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IP 주소" prop="ipaddress">
                <el-input v-model="networkFormData.ipaddress" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="mr-b25">
          <div class="title-bar">
            <div class="title-h4 mr-r10">ICMP</div>
            <el-switch v-model="networkFormData.alivecheckFlagIcmp" :active-value="1" :inactive-value="0"></el-switch>
          </div>
        </div>
        <div class="mr-b25">
          <div class="title-bar">
            <div class="title-h4 mr-r10">SNMP</div>
            <el-switch v-model="networkFormData.alivecheckFlagSnmp" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <div v-show="networkFormData.alivecheckFlagSnmp == 1">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="SNMP 버전" prop="snmpVersion">
                  <el-select v-model="networkFormData.snmpVersion" style="width:100%">
                    <el-option v-for="item in snmpVersionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="SNMP 포트" prop="snmpPort">
                  <el-input v-model="networkFormData.snmpPort" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="networkFormData.alivecheckFlagSnmp == 1 && networkFormData.snmpVersion != 'V3'">
              <el-col :span="12">
                <el-form-item label="커뮤니티 값" prop="snmpCommunityRead">
                  <el-input type="password" v-model="networkFormData.snmpCommunityRead" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
            <div v-show="networkFormData.alivecheckFlagSnmp == 1 && networkFormData.snmpVersion == 'V3'">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="USER" prop="snmpV3Username">
                    <el-input v-model="networkFormData.snmpV3Username" placeholder="입력해 주세요."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Context 명" prop="snmpV3ContextName">
                    <el-input v-model="networkFormData.snmpV3ContextName" placeholder="입력해 주세요."></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Context ID" prop="snmpV3ContextId">
                    <el-input v-model="networkFormData.snmpV3ContextId" placeholder="입력해 주세요."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="height:25px">
                <el-col :span="12">
                  <span>Auth</span>
                </el-col>
                <el-col :span="12">
                  <el-row type="flex" justify="end">
                    <el-switch v-model="networkFormData.authActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                  </el-row>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-show="networkFormData.authActiveFlag == '1'">
                <el-col :span="12">
                  <el-form-item label="프로토콜" prop="snmpV3AuthProtocol">
                    <el-select v-model="networkFormData.snmpV3AuthProtocol" style="width:100%">
                      <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="비밀번호" prop="snmpV3AuthPassword">
                    <el-input type="password" v-model="networkFormData.snmpV3AuthPassword" placeholder="입력해 주세요."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="height:25px">
                <el-col :span="12">
                  <span>Privacy</span>
                </el-col>
                <el-col :span="12">
                  <el-row type="flex" justify="end">
                    <el-switch v-model="networkFormData.privActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                  </el-row>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-show="networkFormData.privActiveFlag == '1'">
                <el-col :span="12">
                  <el-form-item label="프로토콜" prop="snmpV3PrivProtocol">
                    <el-select v-model="networkFormData.snmpV3PrivProtocol" style="width:100%">
                      <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="비밀번호" prop="snmpV3PrivPassword">
                    <el-input type="password" v-model="networkFormData.snmpV3PrivPassword" placeholder="입력해 주세요."></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div>
          <div class="title-bar">
            <div class="title-h4 mr-r10">TCP</div>
            <el-switch v-model="networkFormData.alivecheckFlagTcpport" :active-value="1" :inactive-value="0"></el-switch>
          </div>
          <el-row v-show="networkFormData.alivecheckFlagTcpport == 1">
            <el-form-item label="TCP 포트" prop="alivecheckTcpPort">
              <el-input v-model="networkFormData.alivecheckTcpPort" placeholder="입력해 주세요."></el-input>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
      <el-button size="large" @click="clickCancelButton">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { isNil, assign, clone, cloneDeep } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import ObjtypeAPI from '@/api/model/objtype';
import DeviceRegistrationCommonAPI from '@/api/settings/common/device-registration-common';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

const defaultData = {
  objManagementApplyFlag: '0',
  ipaddressApplytype: 'IPv4',
  snmpVersion: 'V1/V2',
  alivecheckFlagIcmp: 1,
  alivecheckFlagSnmp: 0,
  alivecheckFlagTcpport: 0,
  snmpPort: 161,
  objtypeId: null,
  snmpV3AuthProtocol: 'MD5',
  snmpV3PrivProtocol: 'DES',
};
export default {
  name: 'WAddNetworkPopup',
  data() {
    return {
      isLoading: false,
      networkFormData: clone(defaultData),
      rules: {
        objName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        ipaddress: {
          required: true,
          validator: this.validateIpaddress,
          trigger: 'blur',
        },
      },
      objtypeList: [],
      iptypeList: [],
      snmpVersionList: [],
      snmpAuthList: [],
      snmpPrivList: [],
    };
  },
  methods: {
    loadData() {},
    open() {
      BasicinfoSubAPI.getList('SNMPVER').then((response) => {
        this.snmpVersionList = response.data.data;
      });
      BasicinfoSubAPI.getList('IPTYPE').then((response) => {
        this.iptypeList = response.data.data;
      });
      BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
        this.snmpAuthList = response.data.data;
      });
      BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
        this.snmpPrivList = response.data.data;
      });
      ObjtypeAPI.getObjtypeList('NMS').then((response) => {
        this.objtypeList = response.data.data;
        this.networkFormData.objtypeId = response.data.data[0].objtypeId;
      });
    },
    close() {
      this.$refs.networkForm.resetFields();
      this.networkFormData = clone(defaultData);
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    clickSaveButton() {
      this.$refs.networkForm
        .validate()
        .then((res) => {
          if (res) {
            const target = '네트워크 장비';
            const action = msgUtil.action.REGIST;
            const encryptTargetData = createEncryptTargetData(this.networkFormData, ['snmpCommunityRead', 'snmpV3AuthPassword', 'snmpV3PrivPassword']);
            if (encryptTargetData !== null) {
              getRsaEncrypt(encryptTargetData)
                .then((encryptData) => {
                  this.insertNetdevice(assign(cloneDeep(this.networkFormData), encryptData), action, target);
                })
                .catch((e) => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                  throw new Error(e);
                });
            } else {
              this.insertNetdevice(this.networkFormData, action, target);
            }
          }
        })
        .catch(() => {});
    },
    /**
     * 네트워크 장비를 등록한다.
     * @author Ju
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    insertNetdevice(params, action, target) {
      this.isLoading = true;
      DeviceRegistrationNmsAPI.insertNetdevice(params)
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('re-load');
            this.closePopup();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    clickCancelButton() {
      this.closePopup();
    },
    validateIpaddress(rule, value, callback) {
      const params = {
        objManagetypeId: 'NMS',
        ipaddressApplytype: this.networkFormData.ipaddressApplytype,
      };
      if (this.networkFormData.ipaddressApplytype === 'IPv4') {
        params.ipaddressIpv4 = value;
        if (isNil(value) || value === '') {
          callback(new Error('필수 정보입니다.'));
        }
        if (validateIpv4(value)) {
          DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
            if (response.data.data) {
              this.networkFormData.ipaddressIpv4 = value;
              callback();
            } else {
              callback(new Error('이미 사용 중인 IP입니다.'));
            }
          });
        } else {
          callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
        }
      } else {
        params.ipaddressIpv6 = value;
        if (isNil(value) || value === '') {
          callback(new Error('필수 정보입니다.'));
        }
        if (validateIpv6(value)) {
          DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
            if (response.data.data) {
              this.networkFormData.ipaddressIpv6 = value;
              callback();
            } else {
              callback(new Error('이미 사용 중인 IP입니다.'));
            }
          });
        } else {
          callback(new Error('올바른 IPv6 주소형식을 입력해주세요'));
        }
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/AddNetworkPopup.vue